import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { sort } from 'ramda'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  commentsListRequest: ['videoId'],
  commentsListSuccess: ['listData'],
  commentsListFailure: ['listError'],

  commentsSearchRequest: ['searchText'],
  commentsSearchSuccess: ['listData'],
  commentsSearchFailure: ['listError'],

  commentsCreateRequest: ['createParams'],
  commentsCreateSuccess: ['createData'],
  commentsCreateFailure: ['createError'],

  commentsDeleteRequest: ['commentId', 'videoId'],
  commentsDeleteSuccess: ['deleteData'],
  commentsDeleteFailure: ['deleteError'],

  commentsSetCurrent: ['comment']
})

export const CommentTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  listFetching: null,
  listError: null,

  searchFetching: null,
  searchError: null,

  createData: [],
  createFetching: null,
  createError: null,

  deleteData: [],
  deleteFetching: null,
  deleteError: null,

  currentComment: {}
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ listFetching: true, listError: null })

export const listSuccess = (state, { listData }) =>
  state.merge({ listFetching: false, listData })

export const listFailure = (state, { listError }) => {
  return state.merge({ listFetching: false, listError })
}

export const searchRequest = (state) =>
  state.merge({ searchFetching: true, searchError: null })

export const searchSuccess = (state, { listData }) =>
  state.merge({ searchFetching: false, listData })

export const searchFailure = (state, { searchError }) => {
  return state.merge({ searchFetching: false, searchError })
}

export const createRequest = (state) =>
  state.merge({ createFetching: true, createError: null })

export const createSuccess = (state, { createData }) =>
  state.merge({ createFetching: false, createData })

export const createFailure = (state, { createError }) => {
  return state.merge({ createFetching: false, createError })
}

export const deleteRequest = (state) =>
  state.merge({ deleteFetching: true, deleteError: null })

export const deleteSuccess = (state, { deleteData }) =>
  state.merge({ deleteFetching: false, deleteData })

export const deleteFailure = (state, { deleteError }) => {
  return state.merge({ deleteFetching: false, deleteError })
}

export const setCurrent = (state, { comment }) => {
  return state.merge({ currentComment: comment })
}

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const CommentSelectors = {
  timeLineComments: state => sort((a, b) => {
    return a.time - b.time
  }, state.comments.listData)
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.COMMENTS_LIST_REQUEST]: listRequest,
  [Types.COMMENTS_LIST_SUCCESS]: listSuccess,
  [Types.COMMENTS_LIST_FAILURE]: listFailure,

  [Types.COMMENTS_SEARCH_REQUEST]: searchRequest,
  [Types.COMMENTS_SEARCH_SUCCESS]: searchSuccess,
  [Types.COMMENTS_SEARCH_FAILURE]: searchFailure,

  [Types.COMMENTS_CREATE_REQUEST]: createRequest,
  [Types.COMMENTS_CREATE_SUCCESS]: createSuccess,
  [Types.COMMENTS_CREATE_FAILURE]: createFailure,

  [Types.COMMENTS_DELETE_REQUEST]: deleteRequest,
  [Types.COMMENTS_DELETE_SUCCESS]: deleteSuccess,
  [Types.COMMENTS_DELETE_FAILURE]: deleteFailure,

  [Types.COMMENTS_SET_CURRENT]: setCurrent
})



// WEBPACK FOOTER //
// ./src/Redux/CommentRedux.js